import { render } from "./MaatComputers.vue?vue&type=template&id=bf647974"
const script = {}

import "./MaatComputers.vue?vue&type=style&index=0&id=bf647974&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__